import { makeStyles, Typography } from '@material-ui/core';
import clsx from 'clsx';
import i18n from 'i18n';
import { DashboardProps } from 'modules/advisors/interfaces';
import { CompanyData, RolesEnum } from 'modules/authenticate/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import { inAdminView, inOperatorView, inSuperAdminView } from 'utils/role';
import GenericCard from './GenericCard';
import styles from './styles';

const useStyles = makeStyles(styles);

interface PendingCardProps {
  dashboard: DashboardProps | null;
  companySelected: CompanyData | null;
  role?: RolesEnum;
}

const PendingCard = ({
  dashboard,
  companySelected,
  role,
}: PendingCardProps) => {
  const classes = useStyles();
  return (
    <GenericCard
      title={i18n.t('ADVISOR_PAGE.TOTAL_ADVISORS_SUGGESTED_KEY')}
      content={
        <Typography
          className={clsx(classes.bigNumber, {
            [classes.bigNumberSuperAdmin]: inSuperAdminView(
              role,
              companySelected
            ),
            [classes.bigNumberAdmin]: inAdminView(role, companySelected),
            [classes.bigNumberOperator]: inOperatorView(role, companySelected),
            [classes.bigNumberCompanyContext]: companySelected,
          })}
        >
          {dashboard?.advisors_count}
        </Typography>
      }
    />
  );
};

const mapStateToProps = ({
  advisors: { dashboard },
  authenticate: { data, companySelected },
}: ApplicationState) => ({
  dashboard,
  companySelected,
  role: data?.role,
});

export default connect(mapStateToProps, {})(PendingCard);
